import axios from 'axios';
import { getUserFromLS } from '../utils/getUserFromLS';
import { IClientLimitStatus } from '../Types/user';

export const getClientLimitStatusAsync = async (
  clientId: string
): Promise<IClientLimitStatus> => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/limits/client/${encodeURIComponent(clientId)}/status`;

  const response = await axios.get<IClientLimitStatus>(URL, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });

  return response.data;
};
